export default __webpack_public_path__ + "static/media/250.c85e1fdc.jpg";